function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 8">
      <path d="m12 6-2 2-4-4-4 4-2-2 6-6 6 6Z" fill="currentColor" />
    </svg>
  );
}

export default Icon;
